<template>
	<div class="popover">
		<el-popover placement="top" width="200" v-model="visiblePopover">
			<div class="mb-20">
				<p class="yx-color-text-primary mb-14">{{ errorTitle }}</p>
				<p class="fz-13">{{ errorDesc }}</p>
			</div>
			<div style="text-align: right; margin: 0">
				<el-button size="mini" type="text" @click="visiblePopover = false">取消</el-button>
				<el-button type="primary" size="mini" @click="modifyFun">{{ warnTips }}</el-button>
			</div>
			<p slot="reference" class="warning fz-12 pointer">
				<i class="el-icon-warning mr-4"></i>
				{{ btnTips }}
				<i class="el-icon-arrow-right ml-4"></i>
			</p>
		</el-popover>
		<modifyDyId ref="modifyDyId" @refresh="refresh"></modifyDyId>
		<addDyHomeUrl ref="addDyHomeUrl" @refresh="refresh"></addDyHomeUrl>
		<addKsHomeUrl ref="addKsHomeUrl" @refresh="refresh"></addKsHomeUrl>
		<addJxHomeUrl ref="addJxHomeUrl" @refresh="refresh"></addJxHomeUrl>
	</div>
</template>
<script>
import addDyHomeUrl from '@/views/common/dialog/addDyHomeUrl';
import addKsHomeUrl from '@/views/common/dialog/addKsHomeUrl';
import modifyDyId from '@/views/common/dialog/modifyDyId';
import addJxHomeUrl from '@/views/common/dialog/addJxHomeUrl';
export default {
	components: {
		modifyDyId,
		addDyHomeUrl,
		addJxHomeUrl,
		addKsHomeUrl,
	},
	props: {
		row: {
			type: Object,
			default: () => {},
		},
	},
	inject: ['refresh'],
	computed: {
		isDyPlatform() {
			const {
				row: { platform_id },
			} = this;
			return this.$isDy(platform_id);
		},
		warnTips() {
			return '前往补充';
		},
		errorTitle() {
			const {
				row: { is_effective },
				isDyPlatform,
			} = this;
			//达人抖音号格式错误
			//未在精选联盟检索到该达人数据
			// todo lsb 三元改为对象的形式
			let desc = '';
			let tip = isDyPlatform ? `无法获取达人信息` : `未获取到达人基础信息`;
			if (!['0', '2'].includes(is_effective)) {
				desc = tip;
			}
			return desc;
		},
		errorDesc() {
			const {
				row: { is_effective },
				isDyPlatform,
			} = this;
			let desc = '';
			let tip = isDyPlatform
				? `由于达人未入住精选联盟导致获取不到数据，您可补充达人主页链接来获取达人基础数据(头像+昵称+抖音号+简介+粉丝量)`
				: `达人基础数据获取失败，您可补充/修改达人主页链接，系统会根据链接重新获取达人数据。`;
			if (!['0', '2'].includes(is_effective)) {
				desc = tip;
			}
			return desc;
		},
		btnTips() {
			const {
				row: { is_effective },
				isDyPlatform,
			} = this;
			let desc = '';
			let tip = isDyPlatform ? `无法获取达人信息` : `未获取到达人基础信息`;
			if (!['0', '2'].includes(is_effective)) {
				desc = tip;
			}
			return desc;
		},
	},
	data() {
		return {
			visiblePopover: false,
		};
	},
	methods: {
		modifyFun() {
			const { row, isDyPlatform } = this;
			const { is_effective } = row;
			if (!['0', '2'].includes(is_effective)) {
				isDyPlatform ? this.$refs.addDyHomeUrl.show(row) : this.$refs.addKsHomeUrl.show(row);
			}
		},
	},
};
</script>
<style lang="less" scoped>
.warning {
	color: @color-warning;
	justify-content: flex-end;
}
</style>